var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 9.66667H10.2583L10.025 9.44167C10.8699 8.46169 11.3343 7.21058 11.3333 5.91667C11.3333 4.84535 11.0157 3.7981 10.4205 2.90733C9.82527 2.01656 8.9793 1.3223 7.98954 0.912322C6.99977 0.502347 5.91066 0.395079 4.85993 0.604082C3.8092 0.813085 2.84404 1.32897 2.08651 2.08651C1.32897 2.84404 0.813085 3.8092 0.604082 4.85993C0.395079 5.91066 0.502347 6.99977 0.912322 7.98954C1.3223 8.9793 2.01656 9.82527 2.90733 10.4205C3.7981 11.0157 4.84535 11.3333 5.91667 11.3333C7.25834 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5d0097fd05e4b867af5443cdca3a5a17.svg";
export { ForwardRef as ReactComponent };